module.exports = __webpack_public_path__ + "img/NBerserker64_ua.92ebb401.webp";